import {
	SECTORS_ADD_PDC,
	SECTORS_GET_MANAGER_USERS_LIST, SECTORS_GET_PDCS, SECTORS_REMOVE_PDC,
	SECTORS_SET_PAGINATION, SECTORS_SET_PDCS,
} from "../types";

export const getSectorsList = data => {
	return (dispatch, getState) => {
		const state = getState();

		dispatch(setPagination(data.page, state.sectors.pages));
	};
};

export const getManagerUsersList = () => {
	return { type: SECTORS_GET_MANAGER_USERS_LIST };
};

export const setPagination = (page, pages) => ({
	type: SECTORS_SET_PAGINATION,
	page,
	pages,
});

export const init = () => {
	return (dispatch, getState) => {
		const state = getState();

		dispatch(setPagination(1, state.sectors.pages));
		dispatch(getManagerUsersList());
	};
};

export const getPDCS = () => ({
	type: SECTORS_GET_PDCS,
});

export const setPDCS = (pdcs) => ({
	type: SECTORS_SET_PDCS,
	pdcs,
});

export const addPDC = (sector_id, pdc_id) => ({
	type: SECTORS_ADD_PDC,
	sector_id,
	pdc_id,
});
export const removePDC = (sector_id, pdc_id) => ({
	type: SECTORS_REMOVE_PDC,
	sector_id,
	pdc_id,
});



// WEBPACK FOOTER //
// src/redux/actions/sectorsActions.js